import { useCallback, useEffect, useState } from "react";
import { fetchAdminVehicleAlertDiagnostics } from "../../../../services/vehicleAlertApi";

const VehicleAlertsAdminPage = ({ onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fetchAdminVehicleAlertDiagnostics();
      setData(result.diagnostics);
    } catch (err) {
      setError(err.message || "Unable to load alert diagnostics.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const d = data;

  return (
    <div className="admin-dashboard admin-vehicle-alerts-dash admin-vehicle-sources-dash--full-width">
      <header className="admin-dashboard__header">
        <div>
          <h1>Vehicle Alerts</h1>
          <p className="muted">Saved searches, rules, and in-app alert event diagnostics.</p>
        </div>
        {onClose ? (
          <button type="button" className="crm-btn crm-btn-secondary" onClick={onClose}>
            Close
          </button>
        ) : null}
      </header>
      {error ? <p>{error}</p> : null}
      {loading ? <p>Loading…</p> : null}
      {d ? (
        <>
          <div className="admin-summary-cards">
            <div className="admin-summary-card">
              <span>Saved searches</span>
              <strong>{d.total_saved_searches}</strong>
            </div>
            <div className="admin-summary-card">
              <span>Active alert searches</span>
              <strong>{d.active_alert_searches}</strong>
            </div>
            <div className="admin-summary-card">
              <span>Active rules</span>
              <strong>{d.active_rules}</strong>
            </div>
            <div className="admin-summary-card">
              <span>Total events</span>
              <strong>{d.total_events}</strong>
            </div>
            <div className="admin-summary-card">
              <span>Unseen</span>
              <strong>{d.unseen_events}</strong>
            </div>
          </div>
          {d.eventsByType?.length ? (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Event type</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {d.eventsByType.map((row) => (
                  <tr key={row.event_type}>
                    <td>{row.event_type}</td>
                    <td>{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default VehicleAlertsAdminPage;
